import React, { FC, memo } from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { DATA_TEST_IDS } from '../consts';
import type { AudioReportActionButtonsProps } from './types';

import styles from './index.module.scss';

const AudioReportActionButtons: FC<AudioReportActionButtonsProps> = ({
  closeButtonText,
  isRequestDisabled,
  isRequestLoading,
  requestButtonText,
  onClose,
  onRequestSubmit,
}) => (
  <>
    <Button
      elementId={DATA_TEST_IDS.REPORT_CANCEL_BUTTON}
      type={ButtonType.SECONDARY}
      className={styles.button}
      onClick={onClose}>
      {closeButtonText}
    </Button>
    <Button
      elementId={DATA_TEST_IDS.REPORT_SUBMIT_BUTTON}
      type={ButtonType.PRIMARY}
      className={styles.button}
      isLoading={isRequestLoading}
      isDisabled={isRequestDisabled}
      onClick={onRequestSubmit}>
      {requestButtonText}
    </Button>
  </>
);

export default memo(AudioReportActionButtons);
